// extracted by mini-css-extract-plugin
module.exports = {"feedContainer":"RssFeed_feedContainer__OdQi6","title":"RssFeed_title__3Uzcg","feedError":"RssFeed_feedError__3H9aj"};